/**
 * Jotai atoms for preorder details drawer state management
 *
 * The drawer state is URL-driven:
 * - URL format: /:servicesProviderId/preorders/:tabId/:preorderId/:detailsTab
 * - When preorderId and detailsTab params are present, drawer is open
 * - When they are absent, drawer is closed
 */

import { atom } from 'jotai';

import type { PreordersTableRow } from '@ekhodealer/ekho-common';

export const PREORDER_DETAILS_TAB = {
	DETAILS: 'details',
} as const;

export type PreorderDetailsTab = (typeof PREORDER_DETAILS_TAB)[keyof typeof PREORDER_DETAILS_TAB];

export interface PreorderDetailsDrawerState {
	/** The preorder ID from URL params — always set when drawer is open, even if the row isn't in the current search page. */
	preorderId: string | null;
	selectedRow: PreordersTableRow | null;
}

export const preorderDetailsDrawerAtom = atom<PreorderDetailsDrawerState>({
	preorderId: null,
	selectedRow: null,
});
